<template>
    <div class="login-page container">
        <div class="columns is-centered">   
            <div class="column is-half">
                <h1 class="title">Change Password</h1>
                
              <form @submit.prevent="onSubmit">
                    <b-field label="New Password">
                        <b-input type="password" name="newPassword" v-model="passwordData.newPassword"/>
                    </b-field>
                    <b-field label="Confirm Password">
                        <b-input type="password" name="confirmPassword" v-model="passwordData.confirmPassword"/>
                    </b-field>
                    <p>{{passwordMatchMsg}}</p>
                    <div class="button-container">
                      <button class="button is-primary is-medium">Change Password</button>
                    </div>
              </form>
            </div>
        </div>
    </div>
</template>

<script>

export default {

  components:{
  },
  name: 'ChangePassword',
  data () {
    return {
      passwordData: {
        recid: null,
        newPassword: null,
        confirmPassword: null
      },
      errorMsg: null
    }
  },
  
  
  computed: {
    userInfo: function(){
      return this.$store.state.userInfo;
    }, 
    userId: function(){
      return this.userInfo.recid;
    },
    passwordMatchMsg: function(){
      if( this.passwordData.newPassword == null || this.passwordData.confirmPassword == null ){
        return null;
      }else if ( this.passwordData.newPassword === this.passwordData.confirmPassword ){
        return null;
      }
      return "Passwords do not match";
    }
  },
  
  created() {
    this.passwordData.recid = this.userId;
  },
  
  methods:{
    
    onSubmit(){
      var self = this;
      var url = 'api/v2/changePassword.php?';
      this.$http.post(url, self.passwordData)
      .then( response => {
          console.log(response);
        if(response.data.messages[0].code != 0){
          self.errorMsg = response.data.messages[0].message;
          self.$snotify.error(self.errorMsg, {showProgressBar: false});
          return;
        }else{
          self.$snotify.success('Updated Successfully', {showProgressBar: false});
          self.$router.replace({ name: 'DashboardPage'});
        }
      })
      .catch( error => {
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
          self.errorMsg = error.response.status;
        } else if (error.request) {
          console.log(error.request);
          self.errorMsg = "Unknown Error";
        } else {
          console.log('Error', error.message);
          self.errorMsg = "Unknown Error";
        }
      });
 
    }
    
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.button-container{
  margin-top: 20px;
}
input{
  margin-bottom: 15px;
}

</style>



// WEBPACK FOOTER //
// src/pages/ChangePassword.vue